var _sentryCollisionFreeGlobalObject = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {};
_sentryCollisionFreeGlobalObject["__sentryRewritesTunnelPath__"] = undefined;
_sentryCollisionFreeGlobalObject["SENTRY_RELEASE"] = {"id":"e34ff4aac833bb96558f66999c6b53b0ef72718c"};
_sentryCollisionFreeGlobalObject["__sentryBasePath"] = undefined;
_sentryCollisionFreeGlobalObject["__rewriteFramesAssetPrefixPath__"] = "";

// Client-side error monitoring (Better Stack Errors app WinIt-webapp, via the Sentry SDK).
// Auto-loaded by @sentry/nextjs via the webpack plugin injected in next.config.js.
import * as Sentry from "@sentry/nextjs"

// Google Translate and the Google Search App inject scripts that recurse until the
// stack overflows. Their frames point at the page URL, never at our /_next/ chunks.
function isInjectedStackOverflow(event) {
  const exception = event.exception?.values?.[0]
  if (exception?.type !== "RangeError") return false
  if (!exception.value?.includes("Maximum call stack size exceeded")) return false
  const frames = exception.stacktrace?.frames || []
  return !frames.some((frame) => frame.filename?.includes("/_next/"))
}

Sentry.init({
  dsn:
    process.env.NEXT_PUBLIC_SENTRY_DSN ||
    "https://QkaeMygXeo3a3eE16uMdvwdZ@s2798105.us-west-2a.betterstackdata.com/2798105",
  environment: process.env.NEXT_PUBLIC_WINIT_ENV || "production",
  tracesSampleRate: 0.1,
  replaysSessionSampleRate: 0,
  replaysOnErrorSampleRate: 0,
  enabled: process.env.NODE_ENV === "production" && process.env.NEXT_PUBLIC_WINIT_ENV !== "development",
  beforeSend(event) {
    if (isInjectedStackOverflow(event)) return null
    return event
  },
})
